// Pickup locations where phlebs can grab supplies. Rendered on the phleb's
// draws map as gold-star markers separate from patient pins. Edit this list
// to add or change locations — coords are seeded for the markers to render
// instantly; the map will fall back to Google geocoding if any coords look off.

export const SERVICE_LOCATIONS = [
  {
    id: 'ocean-2148',
    name: 'Supply Pickup — 2148 Ocean Ave',
    address: '2148 Ocean Avenue, Brooklyn, NY 11229',
    // Approximate lat/lng for instant render; the map will refine on first geocode.
    lat: 40.59842,
    lng: -73.95265,
  },
  {
    id: 'utica-672',
    name: 'Supply Pickup — 672 Utica Ave',
    address: '672 Utica Avenue, Brooklyn, NY 11203',
    lat: 40.65020,
    lng: -73.93350,
  },
];

export default SERVICE_LOCATIONS;
